import Container from '@mui/material/Container';
import { Stack } from "@mui/material";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Box from '@mui/material/Box';
import AddRoundedIcon from '@mui/icons-material/AddRounded';





export const Welcome = (props) => {


  return (<>
    <Container maxWidth={false}>
      <Box sx={{ flexGrow: 1, height: 30, display: { xs: 'none', md: 'flex' }}}/>
        <h2 align="center">Willkommen im Linux-Café Stuttgart</h2>
        <Stack direction="column" spacing={1} sx={{ justifyContent: "flex-start", alignItems: "flex-start" }}>
          <p align='left'>Hier gibt es Informationen und Kontakt zu Beratung und Hilfe rund um Linux.</p>
          <p align='left'>Wir wollen Rechner erhalten und möglichst lange benutzbar halten. </p>
          <p align='left'>Dein Rechner verträgt kein Windows 11 oder Du willst unabhängig von Software-Konzernen werden?
                      <p align='left'>Linux Mint ist für die meisten Anwender ein hervorragendes Betriebssystem:
              <List
                sx={{
                  listStyleType: 'disc',
                  pl: 2,
                }}>
            <ListItem sx={{ display: 'list-item', }}>einfache Bedienbarkeit </ListItem>
            <ListItem sx={{ display: 'list-item', }}>stabil</ListItem>
            <ListItem sx={{ display: 'list-item', }}>sicher </ListItem>
            <ListItem sx={{ display: 'list-item', }}>zukunftssicher </ListItem>
            <ListItem sx={{ display: 'list-item', }}>sensibler Umgang mit eigenen Daten </ListItem>
            <ListItem sx={{ display: 'list-item', }}>ist und bleibt kostenlos </ListItem>
              </List>
          </p>
        </p>
        <p align='left'>Auf Demo-PCs kann man bei uns Linux ausprobieren. Wir beraten wann ein Umstieg von Windows sinnvoll ist.</p>
        <p align='left'>Wir unterstützen Dich bei der Installation von Linux auf Deinem Rechner.</p>
        <Stack direction="row" justifyContent="flex-start" alignItems="center">
                    <a target="_blank" rel="noreferrer" href="https://www.linuxcafe-stuttgart.de">
            <img alt="Logo Linuxcafe" width={100} src="LC-Logo_optimiert.svg" /> </a>

                <AddRoundedIcon/>
            <a target="_blank" rel="noreferrer" href="https://repaircafe-kaltental.de/"><img width={100} alt='Logo des Repaircafe Kaltental'
                    src="https://repaircafe-kaltental.de/wp-content/uploads/2025/02/cropped-Logo_RepairCafe2-1-300x300.webp" /></a>

           sind Angebote der
            {/* <a href="https://www.thomasgemeinde-stuttgart.de/begegnungsstaette/ueber-uns" target="_blank" rel="noreferrer">Begegnungsstätte Kaltental</a> */}
          <a target="_blank" rel="noreferrer" href="https://www.thomasgemeinde-stuttgart.de/begegnungsstaette">
            <img alt="Logo der Begegnunsstätte Kaltental" width={100} src="BGSlogo.jpg" /> </a>

        </Stack>

      </Stack>
  </Container >
  </>
  )
}